module.exports = __webpack_public_path__ + "static/img/bg-en.087baada.png";